import { Guid, Nillable } from '@web/utils';
import { FormControl, FormGroup } from '@angular/forms';
import { AdminBannerStatus } from '../enums/admin-banner-status';
import { AdminMultimediaImageUpload } from '@web/shared/module/multimedia';
import { BannerLocationType } from '../../shared/enums/banner-location-type';

export class AdminBannerDetailsForm {
  public constructor(
    private readonly data: {
      fileId: Guid;
      location: BannerLocationType;
      smallFileId?: Nillable<Guid>;
      status: AdminBannerStatus;
      url?: Nillable<string>;
      visibilityEndDate?: Nillable<Date>;
      visibilityStartDate?: Nillable<Date>;
    },
  ) {}

  public get fileId(): Guid {
    return this.data.fileId;
  }

  public get smallFileId(): Nillable<Guid> {
    return this.data.smallFileId;
  }

  public get location(): BannerLocationType {
    return this.data.location;
  }

  public get status(): AdminBannerStatus {
    return this.data.status;
  }

  public get url(): Nillable<string> {
    return this.data.url;
  }

  public get visibilityStartDate(): Nillable<Date> {
    return this.data.visibilityStartDate;
  }

  public get visibilityEndDate(): Nillable<Date> {
    return this.data.visibilityEndDate;
  }
}

export type AdminBannerDetailsFormControls = {
  url: FormControl<Nillable<string>>;
  file: FormControl<Nillable<AdminMultimediaImageUpload>>;
  smallFile: FormControl<Nillable<AdminMultimediaImageUpload>>;
  location: FormControl<Nillable<BannerLocationType>>;
  status: FormControl<Nillable<AdminBannerStatus>>;
  visibilityStartDate: FormControl<Nillable<Date>>;
  visibilityEndDate: FormControl<Nillable<Date>>;
};

/* prettier-ignore */
export type AdminBannerDetailsFormGroup = FormGroup<AdminBannerDetailsFormControls>;
